module.exports = __webpack_public_path__ + "img/icon14.f4dcea98.png";